﻿import "./LoadingScreen.scss";
import loading from "../../assets/loading.svg";
import logo from "../../assets/logo.svg";

export default function LoadingScreen() {
    return (
        <div className="loading-screen">
            <img id="logo-large" alt="StoryChart Logo" src={logo} />
            <img id="loading-indicator" alt="Loading Indicator" src={loading} />
        </div>
    );
}